import React, { useState } from 'react';
import { ServiceStatusModal } from 'components/brikks/home/ServiceStatus/components/ServiceStatusModal';
import Draggable from 'components/drag-and-drop/Draggable';
import { SeeMoreButton } from 'components/form-elements/buttons/SeeMoreButton';
import { BrikkModal } from 'components/modals/BrikkModal';
import { useReportedCases } from 'services/reported-cases';
import { ServiceStatusPreview } from 'components/brikks/home/ServiceStatus/components/ServiceStatusPreview';
import { Brikk } from 'components/Brikk';
import { ServiceIcon } from 'assets/icons/brikks/ServiceIcon';
import { InfoButton } from 'components/form-elements/buttons/InfoButton';
import { BrikkInfoModal } from 'components/modals/BrikkInfoModal';

export const ServiceStatus = ({ position, code, status, name }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);

  const { reportedCases, loading } = useReportedCases();

  const handleInfoModal = (e) => {
    e.stopPropagation();
    setIsInfoModalOpen(!isInfoModalOpen);
  };

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
  };

  return (
    <>
      <Draggable position={position}>
        <Brikk
          isLoading={loading}
          brikkKey={code}
          name={name}
          status={status}
          onClick={handleOpenModal}
        >
          <Brikk.Header
            icon={<ServiceIcon />}
            heading="serviceStatusBrikk"
            brikkKey={code}
            status={status}
          />

          <Brikk.Content center>
            <ServiceStatusPreview
              reportedCases={reportedCases}
              loading={loading}
            />
          </Brikk.Content>

          <Brikk.Button>
            <SeeMoreButton
              onClick={handleOpenModal}
              brikkNameIntl="serviceStatus"
            />
            <InfoButton
              showModal={isInfoModalOpen}
              onClick={handleInfoModal}
            />
          </Brikk.Button>
        </Brikk>
      </Draggable>

      <BrikkInfoModal
        title="Service status info"
        // info={info}
        showModal={isInfoModalOpen}
        onClick={() => setIsInfoModalOpen(!isInfoModalOpen)}
      />

      <BrikkModal
        isOpen={isModalOpen}
        heading="serviceReport"
        onClose={() => setIsModalOpen(false)}
      >
        <ServiceStatusModal />
      </BrikkModal>
    </>
  );
};
